/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { Icon, Link } from '@zapier/design-system';
const Styles = {
    link: {
        fontWeight: 700,
        display: 'grid',
        alignItems: 'center',
        gridTemplateColumns: 'max-content auto',
        columnGap: 5,
    },
};
/** Renders an external link with icon. */
const ExternalLink = ({ className, href, children }) => (isolateComponent(Link, { className: className, css: Styles.link, href: href, target: "_blank" },
    children,
    " ",
    isolateComponent(Icon, { name: "arrowOffsite", size: 18 })));
export default ExternalLink;
